var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-collect"},[_c('section-header',{staticClass:"mt-5 mb-5",attrs:{"title":_vm.header.title,"subtitle":_vm.header.subtitle}}),_c('product-grid',{attrs:{"products":_vm.products}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }